import React from 'react';

const DankePage = () => (
  <div style={{ padding: '2rem', textAlign: 'center' }}>
    <h1>Vielen Dank!</h1>
    <p>Ihre Nachricht wurde erfolgreich übermittelt.</p>
  </div>
);

export default DankePage;
